import { EnterpriseGatewayApiProxy } from '@/api/enterprise-gateway-api.proxy';
import { httpClient } from '@/api/http-client';

const baseUrl = `${import.meta.env.VITE_BASE_URI}`;
export const enterpriseGatewayApiProxy = new EnterpriseGatewayApiProxy(baseUrl, httpClient);
export function useEnterpriseGatewayApiProxy(): EnterpriseGatewayApiProxy {
    return enterpriseGatewayApiProxy;
}
